import { populatedSubscribeKeywordSchema } from "@redotech/redo-model/marketing/subscribe-keyword";
import * as z from "zod/v4";

export const getSubscribeKeywords = {
  name: "getSubscribeKeywords" as const,
  input: z.object({}),
  output: z.object({ keywords: z.array(populatedSubscribeKeywordSchema) }),
};
